import React from 'react';
import styles from '../style.module.scss';
import {Switch} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {DashboardSetting} from "../../../../util/varibles/userSetting";
import {loginActions} from "../../../LoginPage/reducer";
import {selectOneSetting} from "../../../../util/store/selectors";

const Factory: React.FC = () => {
    const dispatch = useDispatch();
    const checked = useSelector(selectOneSetting(DashboardSetting.FACTORIES));

    const onChange = (visible: any) => {
        dispatch(loginActions.updateUserSetting([{[DashboardSetting.FACTORIES]: visible}]))
    };

    return <div className={styles.line}>
        <div className='text-[15px]'>
            Factories
        </div>
        <Switch checked={checked} onChange={onChange}/>
    </div>;
};

export default Factory;
